import {Component, Input} from '@angular/core';
import {BrBioWetterbericht} from '../../../../../../../model/vorhersagen/br-wetterbericht';

@Component({
  selector: 'app-br-biowetter-bericht',
  templateUrl: './br-biowetter-bericht.component.html',
  styleUrls: ['../../wetterbericht.component.css']
})
export class BrBiowetterBerichtComponent {
  @Input() bioWetterbericht: BrBioWetterbericht;
}
